import { useMemo } from 'react'
import { useUser } from '@/lib/hooks'
import { useProject } from '@/contexts/project-context'
import { getUserPermissions, getUserProjectRole } from '@/lib/permissions'

export function usePermissions() {
  const { profile, loading } = useUser()
  const { currentProject, projectMembers } = useProject()

  console.log('=== usePermissions Debug ===')
  console.log('Profile from useUser:', profile)
  console.log('Loading from useUser:', loading)
  console.log('Current project:', currentProject)
  console.log('Project members:', projectMembers)

  const permissions = useMemo(() => {
    console.log('Computing permissions with profile:', profile)

    const projectRole = getUserProjectRole(
      profile?.id,
      currentProject?.id,
      projectMembers
    )

    console.log('Computed project role:', projectRole)

    return getUserPermissions(profile, projectRole)
  }, [profile, currentProject?.id, projectMembers])

  console.log('=== End usePermissions Debug ===')

  return permissions
}